import { LazyRenderLayer } from 'core/layouts/ui-blocks/ReusableComponents';
import { ComponentLoadingScreen } from 'core/navigation/loading-screen/LoadingScreen';
import { homePageNarratorSelector } from 'core/store/reducers/homeReducer/HomeSlice';
import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';

const HomeNarratorModal = lazy(() => import('./HomeNarratorModal'));

function LazyHomeNarratorModal() {
	const isModalOpen = useSelector(homePageNarratorSelector);

	return (
		<LazyRenderLayer isShown={isModalOpen}>
			<Suspense fallback={<ComponentLoadingScreen />}>
				<HomeNarratorModal />
			</Suspense>
		</LazyRenderLayer>
	);
}

export default LazyHomeNarratorModal;
